import React, { useState, useEffect, Fragment, useLayoutEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";

import useClickOutside from "../../hooks/Screen/useClickOutside";
import useRandomWordGenerator from "../../hooks/Random/useRandomWordGenerator";
import { useLazyFetchPersonAllInOrgQuery, useLazyFetchPersonInTableQuery } from "../../utils/customer/customerTable";
import useRequireAuth from "../../utils/useRequireAuth";
import OwnerDropDown from "../GlobalFeature/Fields/OwnerDropDown";
import {
  useAddUpdateUserListMutation,
  useFetchGetAllDataQuery,
  useGetCommonDataBasedOnIdQuery,
  useLazyFetchEditUserDataQuery,
} from "../../utils/customer/customerTaskTable";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { useDispatch } from "react-redux";
import { pushAlert } from "../../utils/alertSlice";
import CustomDrawer from "../UniversalComponents/CustomDrawer";
import DatePickerComponent from "../UniversalComponents/DatePickerComponent";
import BasicSelect from "../Task/BasicSelect";
import { getFlushedDate } from "../../utils/utilityFunctions/dateUtility";
// import crossIcon from "../../assets/images/CrossInActive.svg";
import UserAccessDrawer from "./UserAccessDrawer";
import Button from "../UniversalComponents/DefaultButton";
import LabelComponent from "../UniversalComponents/LabelComponent";
import InputComponent from "../UniversalComponents/InputComponent";
import LoaderWrapper from "../UniversalComponents/CustomLoader";
import SelectComponent from "../UniversalComponents/SelectComponent";
import SectionDivider from "../UniversalComponents/SectionDivider";
import { ReactComponent as CrossIcon } from "../../assets/images/CrossInActive.svg";

const validationRules = {
  first_name: {
    required: true,
    errorMessage: "Cannot be left blank",
  },
  last_name: {
    required: true,
    errorMessage: "Cannot be left blank",
  },
  email: [
    {
      required: true,
      errorMessage: "Cannot be left blank",
    },
    {
      email: true,
      errorMessage: "Provide valid email",
    },
  ],
  // emp_id: {
  //   required: true,
  //   errorMessage: "Cannot be left blank",
  // },
  // designation: {
  //   required: true,
  //   errorMessage: "Cannot be left blank",
  // },
  // department: {
  //   required: true,
  //   errorMessage: "Cannot be left blank",
  // },
  owner: {
    required: true,
    errorMessage: "Select valid email",
  },
  // dob: {
  //   required: true,
  //   errorMessage: "Cannot be left blank",
  // },
  // doj: {
  //   required: true,
  //   errorMessage: "Cannot be left blank",
  // },
  // gender: {
  //   required: true,
  //   errorMessage: "Cannot be left blank",
  // },
  assign_to: {
    required: true,
    errorMessage: "Cannot be left blank",
  },
  // permission_level: {
  //   required: true,
  //   errorMessage: "Cannot be left blank",
  // },
};

const AddUserModal = ({ closePopup, handelsave, editData, title, open }) => {
  const randomWord = useRandomWordGenerator();

  const initialFormData = {
    first_name: "",
    last_name: "",
    //password: "123456789",
    email: "",
    owner: "",
    uuid: "",
    id: "",
    emp_id: "",
    designation: "",
    department: "",
    department_name: "",
    reportingTo: "",
    // workLoc: "",
    // language: "",
    country: "",
    // timeZone: "",
    dob: "",
    doj: "",
    gender: "",
    assign_to: "",
    permission_level: "",
    // seattingLocation: "",
    // Id : "",
    company: [],
    org: {},
  };

  const [formData, setFormData] = useState(initialFormData);
  // const [isExternalUser, setIsExternalUser] = useState(false);
  const [groupData, setGroupData] = useState([]);

  const [isCompanyValid, setIsCompanyValid] = useState(false);

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });

  const { token } = useRequireAuth();

  const dispatch = useDispatch();

  const [fetchPersonInTable, { data: personTableData }] = useLazyFetchPersonAllInOrgQuery({ token });

  useEffect(() => {
    fetchPersonInTable({});
  }, []);

  const { data: fetchGroupData, isFetching } = useGetCommonDataBasedOnIdQuery(
    { token },
    { refetchOnMountOrArgChange: true }
  );

  // const fetchGroupData = async () => {
  //   const getData = await getCommonDataBasedOnId(GET_GROUP_DATA, token);
  //   console.log(getData?.success, "getDataVinay");
  //   if (getData?.success) {
  //     setGroupData(getData?.data);
  //   }
  // };

  //  useEffect(() => {
  //     fetchGroupData();
  //   }, []);

  useEffect(() => {
    if (fetchGroupData) {
      setGroupData(fetchGroupData.data);
    }
  }, [fetchGroupData]);
  const handleClose = () => {
    closePopup();
  };

  const genderArray = [
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
  ];

  const companyId = JSON.parse(localStorage.getItem("company_data"))?.company_id;
  const fetchPersonData = (data) => {
    fetchPersonInTable({ token: token, data: data, companyId: companyId });
  };

  // const {
  //   data: editUserData,
  //   isLoading,
  //   refetch: refetchUserData,
  // } = useFetchEditUserDataQuery({ uuid: editData, token }, { refetchOnMountOrArgChange: true });

  const [triggerFetchEditUserData, { data: editUserData, isLoading }] = useLazyFetchEditUserDataQuery();

  useEffect(() => {
    if (editData) {
      triggerFetchEditUserData({ uuid: editData, token });
    }
  }, [editData]);

  useEffect(() => {
    if (editUserData?.success) {
      const updatedData = {
        ...editUserData?.data,
        assign_to: editUserData?.data.assign_to ?? "",
        permission_level: editUserData?.data.access_level ?? "", // Set to blank if assign_to is null or undefined
      };
      setFormData(updatedData);
      setGroupAccess(editUserData?.data?.assign_to);
      // setIsPermissionOpen(true)
    }
  }, [editUserData, groupData]);

  // useEffect(() => {
  //   fetchTaskEditData(editData);
  // }, [editData]);

  useEffect(() => {
    // Add an event listener for the keydown event
    const handleEscKey = (event) => {
      if (event.key === "Escape") {
        closePopup(); // Close the popup when Escape key is pressed
      }
    };

    window.addEventListener("keydown", handleEscKey);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("keydown", handleEscKey);
    };
  }, [closePopup]);

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPermissionOpen, setIsPermissionOpen] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState([]);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const isPopupOpenclickoutside = useClickOutside(() => {
    setIsPopupOpen(false);
  });

  const setGroupAccess = (value) => {
    const newSelectedGroup = groupData?.find((item) => item.group_id === value);
    setSelectedGroup(newSelectedGroup?.modules);

    const newOrg = {
      group_id: newSelectedGroup?.group_id,
      permission_id: newSelectedGroup?.permission_id,
      modules: newSelectedGroup?.modules,
    };
    setFormData((prevFormData) => ({
      ...prevFormData,
      assign_to: value,
      org: { ...prevFormData.org, ...newOrg },
    }));

    // the below settitmeout need to be changed for some better solution in future refactor of this code
    setTimeout(() => {
      setIsPermissionOpen(true);
    }, 300);
  };

  // useLayoutEffect(() => {
  //   // if (Boolean(formData?.assign_to)) {
  //   //   setIsPermissionOpen(true);
  //   // }
  //   console.log(editUserData, "editdata");

  //   if(editUserData?.assign_to){setIsPermissionOpen(true)}
  // }, [editUserData?.assign_to]);

  const handleFieldChange = (e) => {
    const { name, value, checked } = e.target;
    // console.log(name, value, "etargetvlaue");

    if (name === "department") {
      const selectedDepartment = allAddressData?.departments?.find((item) => item.id === value);
      if (selectedDepartment) {
        setFormData((prevFormData) => ({
          ...prevFormData,
          department: selectedDepartment?.id ? selectedDepartment?.id : "0",
          department_name: selectedDepartment?.department,
        }));
      }
    } else if (name === "external") {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: checked ? 1 : 0,
      }));
    } else if (name === "assign_to") {
      // const newSelectedGroup = groupData?.find((item) => item.group_id === value);
      // const newOrg = {
      //   group_id: newSelectedGroup?.group_id,
      //   permission_id: newSelectedGroup?.permission_id,
      //   modules: newSelectedGroup?.modules,
      // };
      // setSelectedGroup(newSelectedGroup?.modules);

      // setFormData((prevFormData) => ({
      //   ...prevFormData,
      //   [name]: value,
      //   org: { ...prevFormData.org, ...newOrg },
      // }));
      setGroupAccess(value);
    }
    // else if (name === "owner") {
    //   const ownerDetails = personTableData?.data?.filter((item) => item.id === value[0]);
    //   // console.log(name, value, ownerDetails[0].email, "hellloItem");
    //   setFormData((prevFormData) => ({
    //     ...prevFormData,
    //     owner: ownerDetails[0]?.email,
    //   }));
    // }
    else {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: value,
      }));
    }
  };

  const tableDetail = {
    tableidclass: "usermodelreporting",
  };

  const handleInsert = (e) => {
    const { name, value } = e.target;
    const ownerDetails = personTableData?.data?.filter((item) => item.id === value[0]);
    // console.log(name, value, ownerDetails[0].email, "hellloItem");
    setFormData((prevFormData) => ({
      ...prevFormData,
      owner: ownerDetails[0]?.email,
    }));
  };

  const handleDateChange = (date) => {
    setFormData((prevData) => ({
      ...prevData,
      dob: date ? date.toISOString().split("T")[0] : "",
    }));
  };

  const handleDateOfJoin = (date) => {
    setFormData((prevData) => ({
      ...prevData,
      doj: date ? date.toISOString().split("T")[0] : "",
    }));
  };

  const [addUpdateUserList, { isLoading: AddUpdateLoading, isError, isSuccess, error }] =
    useAddUpdateUserListMutation();

  // useEffect(() => {
  //   if (AddUpdateLoading) {
  //     dispatch(showLoader());
  //   } else {
  //     dispatch(hideLoader());
  //   }
  // }, [AddUpdateLoading]);

  const { data: allAddressData } = useFetchGetAllDataQuery({
    token: token,
  });
  // console.log(allAddressData, "vinaydata");

  const getMinDate = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 50);
    return date;
  };

  const hideAlert = () => {
    setAlert((prevState) => ({ ...prevState, visible: false }));
  };

  const handleSubmit = async (e) => {
    e.stopPropagation();
    e.preventDefault();

    const formValid = isFormValid();

    if (!formValid) {
      return;
    }

    try {
      const data = {
        ...formData,
        id: editData,
      };

      const response = await addUpdateUserList({ token, data: data });
      // console.log(response, "helloresponse");

      if (response?.data?.success || response?.success || response?.data?.status || response?.data?.data?.success) {
        setFormData(initialFormData);
        closePopup();
        setIsPopupOpen(false);
        // refetchUserData()
        handelsave();
        dispatch(pushAlert({ type: "success", message: response?.data?.message || response?.message, visible: true }));
      } else {
        dispatch(pushAlert({ type: "danger", message: response?.data?.message, visible: true }));
      }
    } catch (err) {
      dispatch(pushAlert({ type: "danger", message: err?.error || err?.message, visible: true }));
    }
  };
  // console.log("EachItem", groupData);

  return (
    <CustomDrawer open={open} onClose={closePopup} showSubDrawer={isPermissionOpen}>
      <div
        className="relative mt-18 bg-white h-full w-full flex flex-col font-poppins rounded-md overflow-hidden no-scrollbar"
        ref={isPopupOpenclickoutside}
      >
        <div className="mx-6 flex items-center justify-between py-4 md:py-3 border-[#BECBD3] rounded-t">
          <h3 className="text-xl text-1D4469 font-500 font-poppins">{title}</h3>
          <button
            onClick={handleClose}
            type="button"
            className="text-[#D2DAE1] w-7 h-7 ms-auto flex justify-center items-center hover:bg-[#F3F5F7] transition-colors duration-200"
            data-modal-hide="assets-modal"
          >
            <CrossIcon className="h-3 w-3" />
          </button>
        </div>
        <div className="border-t border-[#BECBD3]"></div>

        <LoaderWrapper isLoading={isLoading}>
          <form
            className={`w-full grow min-h-0 pt-3 border-[#BECBD3] flex flex-col justify-between  `}
            onSubmit={handleSubmit}
          >
            <div className="grow min-h-0 ">
              <div className="flex flex-col">
                <div className="px-6 py-2 flex items-center justify-between bg-[#C2D0DA4D]">
                  <label className="text-[#383838] text-base font-400 text-nowrap font-poppins  ">
                    Mark this user as external
                  </label>
                  <div className={`flex items-center`}>
                    <label className={`inline-flex items-center cursor-pointer`}>
                      <input
                        type={`checkbox`}
                        name={"external"}
                        value={formData?.external}
                        className={`sr-only peer`}
                        onChange={handleFieldChange}
                      />
                      <div
                        className={`relative w-11 mt-1 h-6 bg-[#969BA9] peer-focus:outline-none rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600`}
                      ></div>
                    </label>
                  </div>
                </div>
                <div className="px-6">
                  {/* <label className="text-1D4469 text-base  font-600 ">Basic Information</label> */}
                  <SectionDivider label={"Basic Information"} />
                </div>
              </div>

              {!formData?.external && (
                <div className="flex flex-col grow min-h-0  justify-between">
                  <div className=" ">
                    {" "}
                    <input
                      name="password"
                      type="password"
                      value={formData?.password ? formData?.password : "123456789"}
                      hidden
                    />
                    <div className="flex w-full items-center justify-between flex-wrap px-6">
                      <div className="grid grid-cols-2 gap-x-4 w-full">
                        <div className="basis-5/5 h-16 mb-2">
                          <LabelComponent labelText="First Name" isMandatory size="small" htmlFor="first_name" />
                          <InputComponent
                            type="text"
                            id="first_name"
                            name="first_name"
                            value={formData?.first_name}
                            onChange={handleFieldChange}
                            height="30px"
                            mandatory
                            placeholder="Enter First Name"
                            error={errors?.first_name}
                          />
                          {/* {errors?.first_name && (
                          <span className="text-red-500 text-xxs  h-5 mt-1">{errors?.first_name}</span>
                        )} */}
                        </div>
                        <div className="basis-5/5 h-16 mb-2 ">
                          <LabelComponent labelText="Last Name" isMandatory size="small" htmlFor="last_name" />

                          <InputComponent
                            type="text"
                            id="last_name"
                            name="last_name"
                            value={formData?.last_name}
                            onChange={handleFieldChange}
                            height="30px"
                            mandatory
                            placeholder="Enter Last Name"
                            error={errors?.last_name}
                          />
                          {/* {errors.last_name && (
                          <span className="text-red-500 text-xxs  h-5 mt-1">{errors.last_name}</span>
                        )} */}
                        </div>
                      </div>
                      <div className="w-full mb-2 h-16 ">
                        {/* {console.log(editUserData, "edituserData")} */}
                        <LabelComponent labelText="Email" isMandatory size="small" htmlFor="email" />

                        <InputComponent
                          type="email"
                          id="email"
                          name="email"
                          value={formData?.email}
                          onChange={handleFieldChange}
                          height="30px"
                          mandatory
                          placeholder="Enter Email ID"
                          isDisabled={editUserData?.data?.email ? true : false}
                          error={errors?.email}
                        />
                        {/* {errors.email && <span className="text-red-500 text-xxs  h-5 mt-1">{errors.email}</span>} */}
                      </div>
                    </div>
                    <div className="px-6">
                      {/* <div className="text-1D4469 text-base font-600 px-6 py-2">Company Information</div> */}
                      <SectionDivider label={"Company Information"} />
                    </div>
                    <div className="flex w-full items-center justify-between flex-wrap  px-6">
                      <div className="flex w-full items-center justify-between mb-1">
                        <div className="w-1/2 h-16 mr-4">
                          <LabelComponent labelText="Employee ID" size="small" htmlFor="emp_id" />
                          <InputComponent
                            type="text"
                            id="emp_id"
                            name="emp_id"
                            value={formData?.emp_id}
                            onChange={handleFieldChange}
                            height="30px"
                            placeholder="Enter Employee ID"
                          />
                          {/* {errors.emp_id && (
                        <span className="text-red-500 text-xxs">
                          {errors.emp_id}
                        </span>
                      )} */}
                        </div>

                        <div className="relative h-16 w-1/2  ">
                          <LabelComponent labelText="Designation " size="small" htmlFor="designation" />
                          <div className="flex items-center justify-end">
                            <BasicSelect
                              size={"medium"}
                              inputBoxSize={"medium"}
                              showSearch={true}
                              name="designation"
                              label="designation"
                              options={allAddressData?.designations?.map((item) => ({
                                label: item.designation,
                                value: item.id,
                              }))}
                              onChange={handleFieldChange}
                              selectedOptions={allAddressData?.designations
                                ?.filter((item) => item.id === Number(formData["designation"]))
                                .map((item) => ({
                                  label: item.designation,
                                  value: item.id,
                                }))}
                            />
                            <div className="absolute flex px-2 pb-2 pointer-events-none py-2">
                              {/* <h4>
                            <i class="bi bi-chevron-down"></i>
                          </h4> */}
                            </div>
                          </div>
                          {/* {errors.designation && (
                        <span className="text-red-500 text-xxs">
                          {errors.designation}
                        </span>
                      )} */}
                        </div>
                      </div>

                      <div className="flex items-center justify-center w-full mb-2">
                        <div className=" relative basis-5/5 h-16 w-1/2 mr-4">
                          <LabelComponent labelText="Department " size="small" htmlFor="department" />
                          {/* {console.log(allAddressData, "helloadressdata")} */}
                          <BasicSelect
                            size={"medium"}
                            inputBoxSize={"medium"}
                            //id={eachField?.id}
                            name="department"
                            label="department"
                            value={formData?.department}
                            showSearch={true}
                            onChange={handleFieldChange}
                            options={allAddressData?.departments?.map((item) => ({
                              label: item.department,
                              value: item.id,
                            }))}
                            selectedOptions={allAddressData?.departments
                              ?.filter((item) => item.id === Number(formData["department"]))
                              .map((item) => ({
                                label: item.department,
                                value: item.id,
                              }))}
                            // isError={errors?.department}
                            // apiCall={eachField?.apiCall}
                          />
                        </div>
                        <div className=" relative basis-5/5 h-16 w-1/2">
                          {/* <label htmlFor="owner" className="block  text-base text-434852 ">
                          <span className="text-sm font-500 text-434852 ">Reporting To</span>
                          <span className=" text-red-500"> *</span>
                        </label> */}
                          <LabelComponent labelText="Reporting To" isMandatory size="small" htmlFor="owner" />

                          {/* <OwnerDropDown
                            disableVScroll
                            tableidclass={tableDetail.tableidclass}
                            fetchPersonInTable={fetchPersonData}
                            DropData={personTableData?.data}
                            // handleInsert={handleInsert}
                            owner={formData?.owner}
                            fieldname={"owner"}
                          /> */}
                          <div className="h-[30px]">
                            <SelectComponent
                              options={personTableData?.data?.map((option) => ({
                                value: option.id,
                                label: option.name,
                                subLabel: option.email,
                              }))}
                              personList
                              // multiSelect
                              onChange={(e) => handleInsert(e)}
                              name="owner"
                              value={personTableData?.data
                                ?.filter((option) => option?.email === formData?.owner)
                                .map((option) => ({
                                  value: option.id,
                                  label: option.name,
                                  subLabel: option.email,
                                }))}
                              // size="small"
                              showSearch
                              boxWidth
                            />
                          </div>
                          {/* {errors.owner && <span className="text-red-500 text-xxs  h-5 mt-1">{errors.owner}</span>} */}
                        </div>
                      </div>
                    </div>
                    <div className="px-6">
                      {/* <span className=" text-1D4469 text-base font-600 font-['Poppins'] capitalize">
                        Additional Information
                      </span> */}
                      <SectionDivider label={"Additional Information"} />
                    </div>
                    <div className="flex w-full items-center justify-between flex-wrap px-6">
                      <div className="flex w-full items-start justify-between">
                        <div className="relative h-16 w-1/2 mr-2">
                          <LabelComponent labelText="Date of Birth" size="small" htmlFor="dob" />

                          <DatePickerComponent
                            name="dob"
                            selected={getFlushedDate(formData.dob)}
                            onChange={handleDateChange}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Select Date of Birth"
                            className="custom-select bg-white rounded max-w-[544px] text-gray-900 text-xs block w-fill"
                            maxDate={new Date()}
                            minDate={new Date("1700-01-01")}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={500}
                            popperPlacement="bottom-end"
                            size={"small"}
                          />
                          {/* {errors.dob && (
                        <span className="text-red-500 text-xxs">
                          {errors.dob}
                        </span>
                      )} */}
                        </div>

                        <div className="relative h-16 w-1/2 pl-2">
                          <LabelComponent labelText="Gender" size="small" htmlFor="gender" />

                          <div className="flex items-center justify-end">
                            {/* <select
                            id={`gender`}
                            name="gender"
                            value={formData?.gender}
                            onChange={handleFieldChange}
                            className={`custom-select bg-white rounded border mt-1 border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 py-0.5 text-xs block w-[18.6rem]`}
                          >
                            <option selected hidden>
                              Select Your Gender
                            </option>
                            <option>Male</option>
                            <option>Female</option>
                          </select> */}
                            <BasicSelect
                              id={"gender"}
                              name={"gender"}
                              options={genderArray}
                              onChange={handleFieldChange}
                              selectedOptions={genderArray
                                .filter((item) => item.value === formData["gender"])
                                .map((item) => ({ label: item.label, value: item.value }))}
                              size={"medium"}
                            />
                            <div className="absolute flex px-2  pointer-events-none">
                              {/* <h4>
                            <i class="bi bi-chevron-down"></i>
                          </h4> */}
                            </div>
                          </div>
                          {/* {errors.gender && (
                        <span className="text-red-500 text-xxs">
                          {errors.gender}
                        </span>
                      )} */}
                        </div>
                      </div>

                      <div className="flex w-full items-center justify-between">
                        <div className="relative h-16 w-1/2 mr-2">
                          <LabelComponent labelText="Date of Joining" size="small" htmlFor="doj" />

                          <DatePickerComponent
                            name="doj"
                            selected={formData?.doj ? new Date(formData?.doj) : null}
                            onChange={handleDateOfJoin}
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Select Date of Joining"
                            className="custom-select max-w-[544px] bg-white rounded text-gray-900 text-xs block "
                            maxDate={new Date()}
                            minDate={getMinDate()}
                            showYearDropdown
                            showMonthDropdown
                            scrollableYearDropdown
                            yearDropdownItemNumber={500}
                            popperPlacement="bottom-end"
                            size={"small"}
                          />
                          {/* {errors.doj && (
                        <span className="text-red-500 text-xxs">
                          {errors.doj}
                        </span>
                      )} */}
                        </div>
                        <div className="relative h-16  w-1/2 "> </div>
                      </div>
                    </div>
                    {/* <div className="px-6 pb-2 ">
                      <span className=" text-gray-700 text-base font-semibold font-['Poppins'] capitalize">
                        Access Level
                      </span>
                    </div> */}
                    <div className="flex w-full items-center justify-between flex-wrap  px-6">
                      <div className="flex w-full items-center ">
                        {/* <div className="w-1/2 h-16 mr-4">
                          <label htmlFor="assign_to" className="block  text-base text-434852">
                            <span className="text-sm font-500 text-434852">Assign To</span>
                            <span className=" text-red-500"> *</span>
                          </label>
                          <div className="flex items-center justify-end">
                            <select
                              id={`assign_to`}
                              name="assign_to"
                              value={formData?.assign_to === null ? "" : formData?.assign_to}
                              onChange={handleFieldChange}
                              className={`custom-select bg-white mt-1 rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 py-0.5 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full
`}
                            >
                              <option selected hidden>
                                Select Group
                              </option>
                              {groupData.map((EachItem, i) => (
                                <option
                                  className="cursor-pointer"
                                  value={EachItem.id}
                                  selected={formData?.assign_to === EachItem.id}
                                  key={EachItem.id}
                                >
                                  {EachItem.group_name}
                                </option>
                              ))}
                            </select>
                            <div className="absolute flex px-2 pt-1 pointer-events-none">
                            </div>
                          </div>
                          {errors.assign_to && (
                            <span className="text-red-500 text-xxs  h-5 mt-1">{errors.assign_to}</span>
                          )}
                        </div> */}

                        <div className="relative h-16 w-full py-1 ">
                          {/* <span className=" text-1D4469 text-base font-600 font-['Poppins'] capitalize">
                              Access Level <span className="text-[#EF4444]">*</span>
                            </span> */}
                          <SectionDivider label={"Access Level"} isMandatory />

                          <div className="flex flex-col">
                            {/* <LabelComponent labelText="Assigned tofdg" isMandatory size="small" htmlFor="assign_to" /> */}
                            <BasicSelect
                              size={"medium"}
                              inputBoxSize={"medium"}
                              name="assign_to"
                              label="Assigned To"
                              onChange={handleFieldChange}
                              options={groupData?.map((item) => ({
                                label: item.group_name,
                                value: item.group_id,
                              }))}
                              selectedOptions={groupData
                                ?.filter((item) => item.group_id === formData["assign_to"])
                                ?.map((item) => ({
                                  label: item.group_name,
                                  value: item.group_id,
                                }))}
                              isError={errors?.assign_to}
                            />
                            {/* {console.log(formData, "helloformdaata")} */}
                            <div className="absolute flex px-2 pt-1 pointer-events-none">
                              {/* <h4>
                            <i class="bi bi-chevron-down"></i>
                          </h4> */}
                            </div>
                          </div>
                          {errors.permission_level && (
                            <span className="text-red-500 text-xxs  h-5 mt-1">{errors.permission_level}</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* external user wala */}
              {Boolean(formData?.external) && (
                <div>
                  <input
                    name="password"
                    type="password"
                    value={formData?.password ? formData?.password : "123456789"}
                    hidden
                  />
                  <div className="grid grid-cols-2 gap-x-4 px-6">
                    <div className="basis-5/5 h-16 mb-2">
                      <LabelComponent labelText="First Name" isMandatory size="small" htmlFor="first_name" />
                      <InputComponent
                        type="text"
                        id="first_name"
                        name="first_name"
                        value={formData?.first_name}
                        onChange={handleFieldChange}
                        height="30px"
                        mandatory
                        placeholder="Enter First Name"
                        error={errors?.first_name}
                      />
                      {/* {errors?.first_name && (
                      <span className="text-red-500 text-xxs  h-5 mt-1">{errors?.first_name}</span>
                    )} */}
                    </div>
                    <div className="basis-5/5 h-16 mb-2">
                      <LabelComponent labelText="Last Name" isMandatory size="small" htmlFor="last_name" />

                      <InputComponent
                        type="text"
                        id="last_name"
                        name="last_name"
                        value={formData?.last_name}
                        onChange={handleFieldChange}
                        height="30px"
                        mandatory
                        placeholder="Enter Last Name"
                        error={errors?.last_name}
                      />

                      {/* {errors.last_name && <span className="text-red-500 text-xxs  h-5 mt-1">{errors.last_name}</span>} */}
                    </div>
                    <div className=" basis-5/5 h-16 mb-2 col-span-2">
                      <LabelComponent labelText="Email" isMandatory size="small" htmlFor="email" />
                      <InputComponent
                        type="email"
                        id="email"
                        name="email"
                        value={formData?.email}
                        onChange={handleFieldChange}
                        height="30px"
                        mandatory={errors.email}
                        placeholder="Enter Email ID"
                        isDisabled={editUserData?.data?.email ? true : false}
                        error={errors?.email}
                      />
                      {/* {errors.email && <span className="text-red-500 text-xxs  h-5 mt-1">{errors.email}</span>} */}
                    </div>
                  </div>

                  <div className="px-6">
                    <SectionDivider label="Company Information" />
                  </div>

                  <div className=" w-full px-6">
                    <div className=" relative basis-1/2 h-16 w-full mb-2">
                      <LabelComponent labelText="Reporting To" htmlFor="owner" isMandatory size="small" />
                      {/* <OwnerDropDown
                        disableVScroll
                        tableidclass={tableDetail.tableidclass}
                        fetchPersonInTable={fetchPersonData}
                        DropData={personTableData?.data}
                        // handleInsert={handleInsert}
                        owner={formData?.owner}
                        fieldname={"owner"}
                      /> */}

                      <SelectComponent
                        options={personTableData?.data?.map((option) => ({
                          value: option.id,
                          label: option.name,
                          subLabel: option.email,
                        }))}
                        personList
                        // multiSelect
                        onChange={(e) => handleInsert(e)}
                        name="owner"
                        value={personTableData?.data
                          ?.filter((option) => option?.email === formData?.owner)
                          .map((option) => ({
                            value: option.id,
                            label: option.name,
                            subLabel: option.email,
                          }))}
                        // size="small"
                        showSearch
                      />

                      {errors.owner && <span className="text-red-500 text-xxs  h-5 mt-1">{errors.owner}</span>}
                    </div>
                  </div>

                  {/* <div className="px-6 py-2">
                    <span className=" text-gray-700 text-base font-semibold font-['Poppins'] mb-1 capitalize">
                      Access Level
                    </span>
                  </div> */}
                  <div className="flex items-center justify-between w-full px-6 ">
                    {/* <div className=" w-1/2 h-16 mr-4">
                      <label htmlFor="assign_to" className="block  text-base mb-1 text-434852">
                        <span className="text-sm font-500 text-434852">Assign To</span>
                        <span className=" text-red-500"> *</span>
                      </label>
                      <div className="flex items-center justify-end">
                        <select
                          id={`assign_to`}
                          name="assign_to"
                          value={formData?.assign_to === null ? "" : formData?.assign_to}
                          onChange={handleFieldChange}
                          className={`custom-select bg-white rounded border border-DFE2E5 focus:outline-hidden focus:ring-0 py-0.5 focus:border-1D5D9B  active:border active:border-DFE2E5 text-gray-900 text-xs block w-full`}
                        >
                          <option selected hidden>
                            Select Group
                          </option>
                          {console.log("EachItem", groupData)}
                          {groupData.map((EachItem, i) => (
                            <option
                              className="cursor-pointer"
                              value={EachItem.id}
                              selected={formData?.assign_to === EachItem.id}
                              key={EachItem.id}
                            >
                              {EachItem.group_name}
                            </option>
                          ))}
                        </select>
                        <div className="absolute flex px-2 pt-1 pointer-events-none">
                        </div>
                      </div>
                      {errors.assign_to && <span className="text-red-500 text-xxs  h-5 mt-1">{errors.assign_to}</span>}
                    </div> */}

                    <div className="relative h-16 w-full">
                      {/* <span className=" text-1D4469 text-base font-600 font-['Poppins'] capitalize">
                          Access Level <span className="text-[#EF4444]">*</span>
                        </span> */}
                      <SectionDivider label={"Access Level"} isMandatory />

                      <div className="flex flex-col">
                        {/* <LabelComponent labelText="Assigned to" isMandatory size="small" htmlFor="assign_to" /> */}
                        <BasicSelect
                          size={"medium"}
                          inputBoxSize={"medium"}
                          name="assign_to"
                          label="Assigned To"
                          onChange={handleFieldChange}
                          options={groupData?.map((item) => ({
                            label: item.group_name,
                            value: item.group_id,
                          }))}
                          selectedOptions={groupData
                            ?.filter((item) => item.group_id === formData["assign_to"])
                            ?.map((item) => ({
                              label: item.group_name,
                              value: item.group_id,
                            }))}
                          isError={errors.assign_to}
                        />

                        <div className="absolute flex px-2 pt-1 pointer-events-none">
                          {/* <h4>
                            <i class="bi bi-chevron-down"></i>
                          </h4> */}
                        </div>
                      </div>
                      {errors.permission_level && (
                        <span className="text-red-500 text-xxs  h-5 mt-1">{errors.permission_level}</span>
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className=" flex px-6 py-4 border-t border-DFE2E5 justify-end text-md w-full gap-3">
              <Button variant="secondary" onClick={() => closePopup()} style={{ width: "88px", height: "30px" }}>
                CANCEL
              </Button>
              <Button
                variant="primary"
                type={"submit"}
                isDisabled={isPermissionOpen && !isCompanyValid}
                style={{ width: "88px", height: "30px" }}
              >
                {editData ? "UPDATE" : "SAVE"}
              </Button>
            </div>
          </form>
        </LoaderWrapper>
      </div>
      {isPermissionOpen && (
        <UserAccessDrawer
          isPermissionOpen={isPermissionOpen}
          setIsPermissionOpen={setIsPermissionOpen}
          formData={formData}
          setFormData={setFormData}
          selectedGroup={selectedGroup}
          setIsCompanyValid={setIsCompanyValid}
          subDrawer
        />
      )}
    </CustomDrawer>
  );
};
export default AddUserModal;
